// The upload size limits (spec/08 §4.19, F-ORG-01 rule 4, F-ORG-04, F-FNB-01), plain values only, so the
// consoles read the very numbers the server enforces (`@clavian/contracts/constants`) without pulling a route
// file — and `@hono/zod-openapi`'s `new Function` — into their bundle. `routes/files.ts` re-exports them.
/** 10 MB. A phone photo is 3–5; anything larger is a camera RAW that nobody means to publish. */
export const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024;
/** 2 MB. A logo is a small mark on a lock screen and a receipt, not a photograph. */
export const MAX_LOGO_UPLOAD_BYTES = 2 * 1024 * 1024;
/** 5 MB. A menu picture is shown as a tile on Sell and the kiosk, never full screen. */
export const MAX_PRODUCT_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024;
//# sourceMappingURL=uploads.js.map